import { Box, Stack, useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { ScreenMobile } from "@/components/common/ScreenMobile";
import { LargeContentBox } from "@/components/common";
import { useSessionContext } from "@/contexts/SessionContext";
import { FitnessDataModal } from "@/pages/home/components/PatientDash/compontents/FitnessDataModal";
import { isReactNativeWebView } from "@/utils/useWebViewBridge";

/**
 * Conteúdo da tela FluxHealth / fitness (FitnessDataModal embutido).
 */
function GoogleHealthContent({ refreshToken }: { refreshToken: string }) {
  return (
    <Box
      sx={{
        p: { xs: 1.5, md: 2 },
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        overflowX: "hidden",
      }}
    >
      <FitnessDataModal embedded active refreshToken={refreshToken} />
    </Box>
  );
}

/**
 * Tela dedicada FluxHealth (rota `/googlehealth`).
 * No mobile usa `ScreenMobile` (fullscreen plana + X, colada no Header).
 */
export function GoogleHealthPage() {
  const { user } = useSessionContext();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const refreshToken = user?.refreshTokenGoogleFit || "";

  const handleClose = () => {
    // No app portable: X volta para a escolha de aplicativo (Vision)
    if (isReactNativeWebView() && window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage("Show Vision");
      return;
    }
    navigate(-1);
  };

  if (isMobile) {
    return (
      <ScreenMobile
        title="FluxHealth"
        subtitle="Dados fitness e métricas de saúde"
        open
        onClose={handleClose}
      >
        <GoogleHealthContent refreshToken={refreshToken} />
      </ScreenMobile>
    );
  }

  return (
    <LargeContentBox>
      <Stack spacing={2} sx={{ width: "100%", minWidth: 0 }}>
        <GoogleHealthContent refreshToken={refreshToken} />
      </Stack>
    </LargeContentBox>
  );
}
